export const fillArrayWithNumbers = (
  initialNumber: number,
  numbersQuantity: number
) => Array.from(new Array(numbersQuantity), (_, i) => i + initialNumber);
